var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
    'section': _vm.hasNoModifier,
    'section--no-bottom-padding': _vm.noBottomPadding,
    'section--no-top-padding': _vm.noTopPadding,
    'section--hero': _vm.isHero,
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }